enum UserRole {
  OWNER = "OWNER",
  DEFAULT = "DEFAULT",
  LOYALTY_PROG_USER = "LOYALTY_PROG_USER",
}

interface RolePaymentConfig {
  requiresPaymentVerification: boolean;
  showUpgradePrompts: boolean;
  description: string;
}

const ROLE_PAYMENT_CONFIG: Record<string, RolePaymentConfig> = {
  [UserRole.OWNER]: {
    requiresPaymentVerification: true,
    showUpgradePrompts: true,
    description: "Entity owner with full billing and settings access",
  },

  [UserRole.LOYALTY_PROG_USER]: {
    requiresPaymentVerification: false,
    showUpgradePrompts: false,
    description: "Loyalty program customer, no admin access",
  },

  [UserRole.DEFAULT]: {
    requiresPaymentVerification: true,
    showUpgradePrompts: true,
    description: "Standard user with full access",
  },
};

const DEFAULT_CONFIG: RolePaymentConfig = {
  requiresPaymentVerification: true,
  showUpgradePrompts: false,
  description: "Unknown role with restricted access",
};

const getRolePaymentConfig = (userRole?: string | null): RolePaymentConfig => {
  if (!userRole) return DEFAULT_CONFIG;
  return ROLE_PAYMENT_CONFIG[userRole] || DEFAULT_CONFIG;
};

export const requiresPaymentVerification = (
  userRole?: string | null
): boolean => {
  return getRolePaymentConfig(userRole).requiresPaymentVerification;
};

export const shouldShowUpgradePrompts = (userRole?: string | null): boolean => {
  return getRolePaymentConfig(userRole).showUpgradePrompts;
};
